import { Col, Row } from 'react-bootstrap';
import React from 'react';
import { getOrgTermsContent } from '../../content/utils.js';
import styles from './ProjectsLimit.module.css';

const projectsLimitImg = (
  <img
    src="../../../static/images/projects-limit.png"
    alt="Propjects Limit img"
    sizes="432x324"
    className="empty-img"
  />
);

const ProjectsLimit = () => (
  <div className={`${styles.empty} flex`} style={{ backgroundColor: '#fff' }}>
    <div className="component component-hide-border">
      <Row style={{ display: 'flex', alignItems: 'center' }}>
        <React.Fragment>
          <Col sm={6}>
            <div className="img empty-img">{projectsLimitImg}</div>
          </Col>
          <Col sm={6}>
            <div className="text-left empty-info">
              <div className="empty-titles m-b-24">
                <h1 className="h1 m-b-16">
                  Maximum {getOrgTermsContent('projects')} Limit Reached
                </h1>
              </div>
              <div className="empty-desc text-muted m-b-24">
                <p>
                  {getOrgTermsContent('limitedNewProjectMessage')}
                  <a href="mailto:pricing@changesync.com">
                    {' '}
                    pricing@changesync.com
                  </a>
                  .
                </p>
              </div>
            </div>
          </Col>
        </React.Fragment>
      </Row>
    </div>
  </div>
);

export default ProjectsLimit;
